import {Box, Button, Dialog, Paper, Typography} from "@mui/material";
import React from "react";
import {DeleteForever} from "@mui/icons-material";

export interface DeleteConfirmationDialogProps {
  open: boolean
  onConfirm: () => void
  onClose: () => void
}

export const DeleteConfirmationDialog = ({open, onConfirm, onClose}: DeleteConfirmationDialogProps) => <>
  <Dialog open={open} onClose={onClose}>
    <Paper elevation={1} style={{padding: 25, alignItems: 'right', textAlign: 'center'}}>
      <Typography variant="h5">Do you really want to delete this shortened url?</Typography>
      <Box sx={{width: '100%', textAlign: 'center'}}>
        <Button
          startIcon={<DeleteForever/>}
          variant="contained"
          color="error"
          sx={{mt: 2}}
          onClick={onConfirm}
        >
          Delete
        </Button>
      </Box>
    </Paper>
  </Dialog>
</>